import styled from 'styled-components'
import { getCssFromTheme } from '../../../utils/css'

export const StyledBadgeWrapper = styled.div`
  position: relative;
  display: inline-flex;
  vertical-align: middle;
  flex-shrink: 0;

  &.invisible {
    display: none;
  }
  &.menuItemBadge {
    position: absolute;
    right: 25px;
    top: 17px;

    &:not(.isMini) {
      opacity: 1;
      animation: toBadgeMini 0.7s ease-in;
    }

    &.isMini {
      width: 12px;
      height: 12px;
      position: absolute;
      right: -7px;
      top: 12px;
      background-color: ${({ backgroundColor }) => backgroundColor};
      border-radius: 50%;
      margin-left: auto;
      opacity: 1;

      span {
        position: relative;
        height: 8px;
        min-width: 8px;
        padding: 0;
        transform: none;
        top: 2px;
        right: -2px;
      }
    }
  }

  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
    &.menuItemBadge.isMini {
      right: -2px;
    }
  }

  @keyframes toBadgeMini {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`

export const StyledBadge = styled.span`
  ${({ theme, variant }) => getCssFromTheme(theme, 'badge', variant)};
  position: absolute;
  min-width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 5px;
  box-sizing: border-box;
  color: ${({ color }) => color};
  background-color: ${({ backgroundColor }) => backgroundColor};
  border: ${({ borderColor }) => borderColor && `1px solid ${borderColor}`};
  border-radius: 12px;

  &.badgeOnly {
    position: relative;
  }

  &.invisible {
    transition: transform 195ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }

  &.anchorTopRight {
    top: 0;
    right: 0;
    transform: scale(1) translate(50%, -50%);
    transform-origin: 100% 0%;
    &.invisible {
      transform: scale(0) translate(50%, -50%);
    }
  }
  &.anchorTopLeft {
    top: 0;
    left: 0;
    transform: scale(1) translate(-50%, -50%);
    transform-origin: 0% 0%;
    &.invisible {
      transform: scale(0) translate(-50%, -50%);
    }
  }
  &.anchorBottomRight {
    bottom: 0;
    right: 0;
    transform: scale(1) translate(50%, 50%);
    transform-origin: 100% 100%;
    &.invisible {
      transform: scale(0) translate(50%, 50%);
    }
  }
  &.anchorBottomLeft {
    bottom: 0;
    left: 0;
    transform: scale(1) translate(-50%, 50%);
    transform-origin: 0% 100%;
    &.invisible {
      transform: scale(0) translate(-50%, 50%);
    }
  }
`
